import React from 'react';
import classNames from 'classnames';
import Pagination from '../pagination';
import styles from './pagination-regular.scss';

const PaginationRegular = props =>
  <Pagination
    className={styles.container}
    arrowClass={styles.arrow}
    innerClass={styles.page}
    activeClass={classNames(styles.active, 'button-color')}
    {...props}
  />;

export default PaginationRegular;



// WEBPACK FOOTER //
// ./app/components/pagination-regular/pagination-regular.js